<div>

  <div class='layer-style-row' *ngFor="let custom_colors of master_custom_colors.styles; index as i">
    <div class="color-selector-mode-title"
      (click)="hiddenColors[custom_colors.title]=!hiddenColors[custom_colors.title]">
      <span>{{custom_colors.title}}</span>
      <button class="btn-transparent">
        <img [ngClass]="{'rotate-up':hiddenColors[custom_colors.title]}" src="/assets/img/tools/angle-down.svg" alt="">
      </button>
    </div>
    <div class='layer-styles'
      [ngClass]="{'hidden':hiddenColors[custom_colors.title], 'fullheight':master_custom_colors.styles.length === 1}">
      <div class='color-selector-mode' *ngIf="custom_colors.styles.available && custom_colors.styles.available.normal">
        <div class="color-selector-subtitle">
          <span>AVAILABLE > NORMAL</span>
        </div>
        <!-- <div class="color-selector-row" *ngIf="custom_colors.styles.available.normal.none.fillStyle"> -->
        <div class="color-selector-row">
          <div>
            <span class="me-3">fillStyle:</span>
          </div>
          <div>
            <input class="colorpicker-input" [(ngModel)]="custom_colors.styles.available.normal.none.fillStyle"
              [value]="custom_colors.styles.available.normal.none.fillStyle"
              [style.background]="custom_colors.styles.available.normal.none.fillStyle"
              [(colorPicker)]="custom_colors.styles.available.normal.none.fillStyle">
          </div>
        </div>
        <div class="color-selector-row">
          <div>
            <span class="me-3">fill-opacity:</span>
          </div>
          <div>
            <input class="colorpicker-input" type="text"
              [(ngModel)]="custom_colors.styles.available.normal.none['fill-opacity']">
          </div>
        </div>
        <div class="color-selector-row">
          <div>
            <span class="me-3">strokeStyle:</span>
          </div>
          <div>
            <input class="colorpicker-input" [(ngModel)]="custom_colors.styles.available.normal.none.strokeStyle"
              [value]="custom_colors.styles.available.normal.none.strokeStyle"
              [style.background]="custom_colors.styles.available.normal.none.strokeStyle"
              [(colorPicker)]="custom_colors.styles.available.normal.none.strokeStyle">
          </div>
        </div>
        <div class="color-selector-row">
          <div>
            <span class="me-3">stroke-opacity:</span>
          </div>
          <div>
            <input class="colorpicker-input" type="text"
              [(ngModel)]="custom_colors.styles.available.normal.none['stroke-opacity']">
          </div>
        </div>
        <div class="color-selector-row">
          <div>
            <span class="me-3">lineWidth:</span>
          </div>
          <div>
            <input class="colorpicker-input" type="text"
              [(ngModel)]="custom_colors.styles.available.normal.none.lineWidth">
          </div>
        </div>
      </div>
      <div class='color-selector-mode' *ngIf="custom_colors.styles.available && custom_colors.styles.available.hover">
        <div class="color-selector-subtitle">
          <span>AVAILABLE > HOVER</span>
        </div>
        <div class="color-selector-row">
          <div>
            <span class="me-3">fillStyle:</span>
          </div>
          <div>
            <input class="colorpicker-input" [(ngModel)]="custom_colors.styles.available.hover.none.fillStyle"
              [value]="custom_colors.styles.available.hover.none.fillStyle"
              [style.background]="custom_colors.styles.available.hover.none.fillStyle"
              [(colorPicker)]="custom_colors.styles.available.hover.none.fillStyle">
          </div>
        </div>
        <div class="color-selector-row">
          <div>
            <span class="me-3">fill-opacity:</span>
          </div>
          <div>
            <input type="text" class="colorpicker-input"
              [(ngModel)]="custom_colors.styles.available.hover.none['fill-opacity']">
          </div>
        </div>
        <div class="color-selector-row">
          <div>
            <span class="me-3">strokeStyle:</span>
          </div>
          <div>
            <input class="colorpicker-input" [(ngModel)]="custom_colors.styles.available.hover.none.strokeStyle"
              [value]="custom_colors.styles.available.hover.none.strokeStyle"
              [style.background]="custom_colors.styles.available.hover.none.strokeStyle"
              [(colorPicker)]="custom_colors.styles.available.hover.none.strokeStyle">
          </div>
        </div>
        <div class="color-selector-row">
          <div>
            <span class="me-3">stroke-opacity:</span>
          </div>
          <div>
            <input class="colorpicker-input" type="text"
              [(ngModel)]="custom_colors.styles.available.hover.none['stroke-opacity']">
          </div>
        </div>
        <div class="color-selector-row">
          <div>
            <span class="me-3">lineWidth:</span>
          </div>
          <div>
            <input class="colorpicker-input" type="text"
              [(ngModel)]="custom_colors.styles.available.hover.none.lineWidth">
          </div>
        </div>
      </div>
      <div class='color-selector-mode' *ngIf="custom_colors.styles.selected && custom_colors.styles.selected.normal">
        <div class="color-selector-subtitle">
          <span>SELECTED > NORMAL</span>
        </div>
        <div class="color-selector-row">
          <div>
            <span class="me-3">fillStyle:</span>
          </div>
          <div>
            <input class="colorpicker-input" [(ngModel)]="custom_colors.styles.selected.normal.none.fillStyle"
              [value]="custom_colors.styles.selected.normal.none.fillStyle"
              [style.background]="custom_colors.styles.selected.normal.none.fillStyle"
              [(colorPicker)]="custom_colors.styles.selected.normal.none.fillStyle">
          </div>
        </div>
        <div class="color-selector-row">
          <div>
            <span class="me-3">fill-opacity:</span>
          </div>
          <div>
            <input class="colorpicker-input" type="text"
              [(ngModel)]="custom_colors.styles.selected.normal.none['fill-opacity']">
          </div>
        </div>
        <div class="color-selector-row">
          <div>
            <span class="me-3">strokeStyle:</span>
          </div>
          <div>
            <input class="colorpicker-input" [(ngModel)]="custom_colors.styles.selected.normal.none.strokeStyle"
              [value]="custom_colors.styles.selected.normal.none.strokeStyle"
              [style.background]="custom_colors.styles.selected.normal.none.strokeStyle"
              [(colorPicker)]="custom_colors.styles.selected.normal.none.strokeStyle">
          </div>
        </div>
        <div class="color-selector-row">
          <div>
            <span class="me-3">stroke-opacity:</span>
          </div>
          <div>
            <input class="colorpicker-input" type="text"
              [(ngModel)]="custom_colors.styles.selected.normal.none['stroke-opacity']">
          </div>
        </div>
        <div class="color-selector-row">
          <div>
            <span class="me-3">lineWidth:</span>
          </div>
          <div>
            <input class="colorpicker-input" type="text"
              [(ngModel)]="custom_colors.styles.selected.normal.none.lineWidth">
          </div>
        </div>
      </div>
      <div class='color-selector-mode' *ngIf="custom_colors.styles.selected && custom_colors.styles.selected.hover">
        <div class="color-selector-subtitle">
          <span>SELECTED > HOVER</span>
        </div>
        <div class="color-selector-row">
          <div>
            <span class="me-3">fillStyle:</span>
          </div>
          <div>
            <input class="colorpicker-input" [(ngModel)]="custom_colors.styles.selected.hover.none.fillStyle"
              [value]="custom_colors.styles.selected.hover.none.fillStyle"
              [style.background]="custom_colors.styles.selected.hover.none.fillStyle"
              [(colorPicker)]="custom_colors.styles.selected.hover.none.fillStyle">
          </div>
        </div>
        <div class="color-selector-row">
          <div>
            <span class="me-3">fill-opacity:</span>
          </div>
          <div>
            <input class="colorpicker-input" type="text"
              [(ngModel)]="custom_colors.styles.selected.hover.none['fill-opacity']">
          </div>
        </div>
        <div class="color-selector-row">
          <div>
            <span class="me-3">strokeStyle:</span>
          </div>
          <div>
            <input class="colorpicker-input" [(ngModel)]="custom_colors.styles.selected.hover.none.strokeStyle"
              [value]="custom_colors.styles.selected.hover.none.strokeStyle"
              [style.background]="custom_colors.styles.selected.hover.none.strokeStyle"
              [(colorPicker)]="custom_colors.styles.selected.hover.none.strokeStyle">
          </div>
        </div>
        <div class="color-selector-row">
          <div>
            <span class="me-3">stroke-opacity:</span>
          </div>
          <div>
            <input class="colorpicker-input" type="text"
              [(ngModel)]="custom_colors.styles.selected.hover.none['stroke-opacity']">
          </div>
        </div>
        <div class="color-selector-row">
          <div>
            <span class="me-3">lineWidth:</span>
          </div>
          <div>
            <input class="colorpicker-input" type="text"
              [(ngModel)]="custom_colors.styles.selected.hover.none.lineWidth">
          </div>
        </div>
      </div>
      <div class='color-selector-mode'
        *ngIf="custom_colors.styles.unavailable && custom_colors.styles.unavailable.normal.none">
        <div class="color-selector-subtitle">
          <span>UNAVAILABLE > NORMAL</span>
        </div>
        <div class="color-selector-row">
          <div>
            <span class="me-3">fillStyle:</span>
          </div>
          <div>
            <input class="colorpicker-input" [(ngModel)]="custom_colors.styles.unavailable.normal.none.fillStyle"
              [value]="custom_colors.styles.unavailable.normal.none.fillStyle"
              [style.background]="custom_colors.styles.unavailable.normal.none.fillStyle"
              [(colorPicker)]="custom_colors.styles.unavailable.normal.none.fillStyle">
          </div>
        </div>
        <div class="color-selector-row">
          <div>
            <span class="me-3">fill-opacity:</span>
          </div>
          <div>
            <input class="colorpicker-input" type="text"
              [(ngModel)]="custom_colors.styles.unavailable.normal.none['fill-opacity']">
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="color-apply-container">
  <button class="btn-secondary-action" *ngIf="template && !deleting" (click)="udpdateTemplate(master_custom_colors)"
    [disabled]="uploading" title="Guardar cambios de la plantilla">
    <span *ngIf="!uploading else loading">Guardar</span>
    <ng-template #loading>
      <i class="fa fa-spinner fa-spin fa-1x fa-fw"></i>
    </ng-template>
  </button>

  <button class="btn-secondary-action-lil ms-2" (click)="createMode = true"
    *ngIf="!template && !createMode && !deleting" title="Guardar como plantilla nueva">Crear nueva plantilla</button>
  <!--     <button class="btn-secondary-action ms-2" (click)="applyCustomStyles()" *ngIf="!createMode  && !deleting" title="Aplicar cambios en el mapa">Aplicar</button>
 -->
  <button class="btn-secondary-action" *ngIf="template && !deleting" (click)="deleting = true"
    class="btn-secondary-action ms-auto">Eliminar</button>
  <!--     <button class="btn-secondary-action" *ngIf="!template && !createNewTemplate.values" 
    (click)="createNewTemplate.values = custom_colors">
        Nueva plantilla
    </button>
    <button class="btn-secondary-action ms-2" *ngIf="!createNewTemplate.values" 
    (click)="applyCustomStyles()" title="Aplicar cambios en el site">Aplicar</button>
 -->
</div>

<div *ngIf="createMode" class="template-confirm-wrapper">
  <div>
    <span>Crear nueva plantilla</span>
  </div>
  <div class="d-flex align-items-center justify-content-between">
    <input type="text" class="custom-input mt-0" [(ngModel)]="createNewTemplate.name">
    <button class="btn-secondary-action" (click)="createTemplate()" [disabled]="!createNewTemplate.name">
      <i class="fa fa-save"></i>
    </button>
    <button class="btn-secondary-action" (click)="createMode = false">
      <i class="fa fa-times"></i>
    </button>
  </div>
</div>

<div *ngIf="deleting" class="template-confirm-wrapper">
  <div>
    <span>Esta acción no se podrá deshacer.</span><br>
    <span>¿Eliminar plantilla?</span>
  </div>
  <div class="confirm-btns d-flex align-items-center justify-content-between">
    <button class="btn-secondary-action" (click)="destroyTemplate()">
      Si
    </button>
    <button class="btn-secondary-action" (click)="deleting = false">
      No
    </button>
  </div>
</div>